import { useCallback, useEffect, useState } from 'react';
import { listRecords } from '../services/siteContentService';

const sortByOrder = (records) =>
  [...records].sort((a, b) => Number(a.order || 0) - Number(b.order || 0));

export default function useSiteContent(entity, fallback = []) {
  const [data, setData] = useState(fallback);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const refresh = useCallback(async () => {
    setLoading(true);
    setError('');

    try {
      const records = await listRecords(entity);
      setData(records.length ? sortByOrder(records) : fallback);
    } catch (requestError) {
      setData(fallback);
      setError(requestError.message || 'Unable to load content');
    } finally {
      setLoading(false);
    }
  }, [entity, fallback]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { data, loading, error, refresh };
}